import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export interface BugReportPayload {
  title: string;
  description: string;
  userId: string;
  clubId: string;
  environment: string;
  version: string;
  userEmail: string;
  file?: string;
  fileName?: string;
  mimeType?: string;
}

export interface BugReportResponse {
  success: boolean;
  issueNumber: number;
  issueUrl: string;
  message: string;
}

class BugReportService {
  async submitBugReport(payload: BugReportPayload): Promise<BugReportResponse> {
    const token = localStorage.getItem('token');
    
    if (!token) {
      throw new Error('Authentication required to submit bug reports');
    }

    try {
      const response = await axios.post<{ data: BugReportResponse }>(
        `${API_BASE_URL}/api/bug-reports`,
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data.data;
    } catch (error: any) {
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error.message);
      }
      throw new Error('Failed to submit bug report. Please try again later.');
    }
  }
}

export const bugReportService = new BugReportService();
